export const ContentType = {
    Text: 0,
    Image: 1,
    YoutubeVideo: 2
}